import { setMeta } from '@/helpers/metaHelpers'

export default {
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
  },
}
